module.exports = __webpack_public_path__ + "static/img/img_0707.af3b035.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/img_0707.jpg
// module id = SWxG
// module chunks = 0